import { formatNumber, formatPercent } from "@/utils/format";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import TileEntity from "../TileEntity";

class ApothecaryBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.APOTHECARY;

	public get description(): string {
		return super.description
			.replace(
				"{percent}",
				formatPercent(
					((this.production.get(
						ResourceType.PRODUCTION_RESOURCE_MULTIPLIER,
					)! as number) - 1) as number,
				),
			)
			.replace(
				"{number}",
				formatNumber(
					this.requirements.get(
						ResourceType.SETTLEMENT_LEVEL,
					)! as number,
				),
			);
	}
}

export default ApothecaryBuildingTileEntity;
